// Compute age in completed years from an ISO date string (YYYY-MM-DD or full ISO).
// Returns null for invalid / empty input.
export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  let years = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) years -= 1;
  return Math.max(0, years);
}

// Friendly label: "23 years" / "11 months" / null
export function ageLabel(dob) {
  const y = ageFromDob(dob);
  if (y === null) return null;
  if (y === 0) return "< 1 yr";
  return `${y} yr${y === 1 ? "" : "s"}`;
}
